import { webApi } from "../../../../core/http/httpThunks";
import { Order } from "../types";

export const getOppositeOrder = (userId: string, ordid: string) =>
  webApi<Order>({
    method: "GET",
    url: "order/getoppositeorder",
    params: {
      userId,
      ordid,
    },
  });

export default getOppositeOrder;
